import { type Tack } from '../types';

export type ManeuverVisibility = Record<number, boolean>;
export type ManeuverLabelMap = Record<number, number>;

type Listener = (visibility: ManeuverVisibility) => void;
type LabelListener = (labels: ManeuverLabelMap) => void;

let visibilityState: ManeuverVisibility = {};
let labelState: ManeuverLabelMap = {};
const listeners = new Set<Listener>();
const labelListeners = new Set<LabelListener>();

const notify = () => {
  for (const listener of listeners) {
    listener({ ...visibilityState });
  }
};

const notifyLabels = () => {
  for (const listener of labelListeners) {
    listener({ ...labelState });
  }
};

export const subscribeManeuverVisibility = (listener: Listener): (() => void) => {
  listeners.add(listener);
  listener({ ...visibilityState });
  return () => listeners.delete(listener);
};

export const getManeuverVisibility = (): ManeuverVisibility => ({ ...visibilityState });

export const setManeuverVisibility = (
  updater: ManeuverVisibility | ((previous: ManeuverVisibility) => ManeuverVisibility),
) => {
  const nextState =
    typeof updater === 'function' ? (updater as (prev: ManeuverVisibility) => ManeuverVisibility)(visibilityState) : updater;
  visibilityState = { ...nextState };
  notify();
};

export const subscribeManeuverLabels = (listener: LabelListener): (() => void) => {
  labelListeners.add(listener);
  listener({ ...labelState });
  return () => labelListeners.delete(listener);
};

export const getManeuverLabels = (): ManeuverLabelMap => ({ ...labelState });

export const setManeuverLabels = (labels: ManeuverLabelMap) => {
  labelState = { ...labels };
  notifyLabels();
};

export const ensureManeuverVisibilityForTacks = (tacks: Tack[]) => {
  setManeuverVisibility((previous) => {
    const next: ManeuverVisibility = {};
    for (let index = 0; index < tacks.length; index += 1) {
      next[index] = previous[index] ?? false;
    }
    return next;
  });
};
